export default [
	//产品资源
	{
		path: 'productResource',
		component: () => import('../../sys/resource-center/productResource/index'),
		redirect: '/sys/productResource/product',
		children: [{
				path: 'type',
				component: () => import('../../sys/resource-center/productResource/type')
			},
			{
				path: 'resource',
				component: () => import('../../sys/resource-center/productResource/list')
			}
		]
	},
	// 个人资源库
	{
		path: 'userResource',
		component: () => import('../../sys/resource-center/userResource/index'),
		redirect: '/sys/userResource/resourceKu',
		children: [{
			path: 'resourceKu',
			component: () => import('../../sys/resource-center/userResource/home')
		}]
	}
]